/** Theme store using Svelte 5 runes — persists to localStorage, defaults to system preference */

type ResolvedTheme = "light" | "dark";

function createThemeStore() {
  function initialResolved(): ResolvedTheme {
    if (typeof document !== "undefined") {
      const fromDataset = document.documentElement.dataset.theme;
      if (fromDataset === "light" || fromDataset === "dark") {
        return fromDataset;
      }
      const fromInline = document.documentElement.style.colorScheme;
      if (fromInline === "light" || fromInline === "dark") {
        return fromInline;
      }
    }
    if (typeof matchMedia !== "undefined") {
      return matchMedia("(prefers-color-scheme:dark)").matches
        ? "dark"
        : "light";
    }
    return "light";
  }

  let resolved = $state<ResolvedTheme>(initialResolved());

  function systemPreference(): ResolvedTheme {
    if (typeof matchMedia !== "undefined") {
      return matchMedia("(prefers-color-scheme:dark)").matches
        ? "dark"
        : "light";
    }
    return "light";
  }

  function apply(theme: ResolvedTheme) {
    resolved = theme;
    if (typeof document !== "undefined") {
      document.documentElement.style.colorScheme = theme;
      document.documentElement.dataset.theme = theme;
    }
  }

  function set(t: ResolvedTheme) {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("theme", t);
    }
    apply(t);
  }

  function toggle() {
    set(resolved === "dark" ? "light" : "dark");
  }

  function init() {
    let stored: ResolvedTheme | null = null;
    try {
      stored = localStorage.getItem("theme") as ResolvedTheme | null;
    } catch {
      stored = null;
    }
    if (stored === "light" || stored === "dark") {
      apply(stored);
    } else {
      apply(systemPreference());
    }
  }

  return {
    get resolved() {
      return resolved;
    },
    set,
    toggle,
    init,
  };
}

export const theme = createThemeStore();
